import { SVGProps } from 'react';

const PictureInPicture = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 4v6H2m6 0L2 4m19 6V7a2 2 0 0 0-2-2h-7m-9 9v2a2 2 0 0 0 2 2h3m5-4h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1v-5a1 1 0 0 1 1-1"
    />
  </svg>
);
export default PictureInPicture;
